import request from "../../utils/request";
import { Result } from "../../models/general";
import { UserEducationInput, UserEducationView } from "../../models/employee";

export async function getUserEducations(userId: string) {
    const response = await request.get<Result<UserEducationView[]>>(`Education/GetUserEducations/${userId}`);
    return response.data;
}

export async function addUserEducation(input: UserEducationInput) {
    const response = await request.post<Result<UserEducationView>>("Education/AddUserEducation", input);
    return response.data;
}

export async function editUserEducation(educationId: number, input: UserEducationInput) {
    const response = await request.post<Result<UserEducationView>>(`Education/EditUserEducation/${educationId}`, input);
    return response.data;
}

export async function deleteUserEducation(educationId: number) {
    const response = await request.post<Result<UserEducationView[]>>(`Education/DeleteUserEducation/${educationId}`);
    return response.data;
}